/**
 * The sidebar's game switch: browse everything, only tabletop RPGs, or only wargames. It narrows
 * every browse list.
 */
import { setGameScope, useGameScope, type GameScope } from '../lib/gameScope'

const OPTIONS: Array<{ value: GameScope; label: string; title: string }> = [
  { value: 'all', label: 'All', title: 'Tabletop RPGs and wargames' },
  { value: 'ttrpg', label: 'RPGs', title: 'Tabletop roleplaying games only' },
  { value: 'wargame', label: 'Wargames', title: 'Wargames only' },
]

export function GameSwitch() {
  const scope = useGameScope()
  return (
    <div className="seg game-switch" role="radiogroup" aria-label="Games to browse">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={scope === o.value}
          title={o.title}
          onClick={() => setGameScope(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
